<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form class="form-horizontal">
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.date') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.homework_date }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.class') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.class_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.teacher') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.teacher_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.subject') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.subject_name }}</p>
          </div>
        </div>
        <div class="row">
          <label class="ts-text-xs col-form-label col-md-4"
            >{{ $t('homework.remark') }} :</label
          >
          <div class="col-md-8 text-left">
            <p class="mt-1">{{ resources.remarks }}</p>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <span class="badge badge-info">
              {{ $t('homework.homeworkfile') }}
            </span>
            <div class="ts-p-3">
              <ul>
                <li
                  v-for="(homework, index) in homeworkFile"
                  :key="index"
                  class="ts-float-left ts-px-2"
                >
                  <a
                    href="#"
                    v-tooltip="homework.attach_file_name"
                    @click.prevent="onDownload(homework)"
                  >
                    <a-icon
                      type="file"
                      :style="{ fontSize: '16px', color: '#08c' }"
                      :spin="homework.action"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span class="badge badge-info">
              {{ $t('homework.referenceFile') }}
            </span>
            <div class="ts-p-3">
              <ul>
                <li
                  v-for="(reference, index) in referenceFile"
                  :key="index"
                  class="ts-float-left ts-px-2"
                >
                  <a
                    href="#"
                    v-tooltip="reference.attach_file_name"
                    @click.prevent="onDownload(reference)"
                  >
                    <a-icon
                      type="file"
                      :style="{ fontSize: '16px', color: '#08c' }"
                      :spin="reference.action"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <h1 class="ts-py-3">{{ $t('homework.referenceVideo') }}</h1>
        <div
          class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
        >
          <div class="row">
            <div
              v-for="(refer, index) in referenceVideo"
              :key="index"
              class="col-md-6"
              :class="{ 'form-group': referenceVideo.length > 2 }"
            >
              <iframe
                v-if="refer.url"
                width="100%"
                height="150px"
                :src="'https://www.youtube.com/embed/' + videoId(refer.url)"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
        <div v-if="resources.length > 0">
          <div v-if="resources.student_homework.length > 0">
            <h1 class="ts-py-3">{{ $t('homework.correction') }}</h1>
            <div
              class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
            >
              <div class="row">
                <label class="ts-text-xs col-form-label col-md-4"
                  >{{ $t('homework.score') }} :</label
                >
                <div class="col-md-8 text-left">
                  <p class="mt-1">{{ studentHomework.score }}</p>
                </div>
              </div>
              <div class="row">
                <label class="ts-text-xs col-form-label col-md-4"
                  >{{ $t('homework.comment') }} :</label
                >
                <div class="col-md-8 text-left">
                  <p class="mt-1">{{ studentHomework.teacher_comment }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12">
                  <span class="badge badge-info">
                    {{ $t('homework.answer') }}
                  </span>
                  <div class="ts-p-3">
                    <ul>
                      <li
                        class="ts-float-left ts-px-2"
                        v-for="(answer,
                        index) in studentHomework.student_answer.filter(
                          f => f.attach_type_id == 3
                        )"
                        :key="index"
                      >
                        <a
                          href="#"
                          v-tooltip="answer.original_file_name"
                          @click.prevent="onDownloadAnswer(answer)"
                        >
                          <a-icon
                            type="file"
                            :style="{ fontSize: '16px', color: '#08c' }"
                            :spin="answer.action"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12">
                  <span class="badge badge-info">
                    {{ $t('homework.result') }}
                  </span>
                  <div class="ts-p-3">
                    <ul>
                      <li
                        class="ts-float-left ts-px-2"
                        v-for="(answer,
                        index) in studentHomework.student_answer.filter(
                          f => f.attach_type_id == 4
                        )"
                        :key="index"
                      >
                        <a
                          href="#"
                          v-tooltip="answer.original_file_name"
                          @click.prevent="onDownloadAnswer(answer)"
                        >
                          <a-icon
                            type="file"
                            :style="{ fontSize: '16px', color: '#08c' }"
                            :spin="answer.action"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row mt-3"
          v-if="
            record.is_approvable == 1 &&
              record.request_status != 'Approved' &&
              record.request_status != 'Rejected'
          "
        >
          <div class="col-md-12 text-right">
            <ts-button color="danger" @click="showReasonForm(2, record)">{{
              $t('reject')
            }}</ts-button>
            <ts-button
              class="ml-2"
              color="primary"
              @click.prevent="showReasonForm(1, record)"
              >{{ $t('approve') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import ReasonComponent from './approval-reason'

export default {
  name: 'viewHomework',
  props: ['record'],
  data() {
    return {
      referenceVideo: [],
      resources: []
    }
  },
  computed: {
    homeworkFile() {
      if (_.isEmpty(this.resources)) return []

      return this.resources.homework_attachment.filter(
        att => att.attach_file_type == 1
      )
    },
    referenceFile() {
      if (_.isEmpty(this.resources)) return []

      return this.resources.homework_attachment.filter(
        att => att.attach_file_type == 2
      )
    },
    studentHomework() {
      if (this.resources.length > 0) {
        if (this.resources.student_homework.length > 0) {
          return this.resources.student_homework[0]
        }
      }
      return ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('home/staffMyApproval/find', this.record.request_id)
        .then(response => {
          this.loading = false
          this.resources = response.data
          this.referenceVideo = JSON.parse(response.data.url_reference)
            ? JSON.parse(response.data.url_reference)
            : []
        })
        .catch(() => {
          this.loading = false
        })
    },
    onDownload(record) {
      record.action = true
      this.$store
        .dispatch('eschool/studentHomework/download', {
          filePath: record.attach_file_path
        })
        .then(response => {
          FileDownload(
            response,
            record.attach_file_name,
            record.attach_file_mime_type
          )
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    },
    onDownloadAnswer(record) {
      record.action = true
      this.$store
        .dispatch('eschool/studentHomework/download', {
          filePath: record.file_path
        })
        .then(response => {
          FileDownload(response, record.original_file_name, record.mime_type)
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    },
    videoId(url) {
      return url
        ? url.split('be/')[1]
          ? url.split('be/')[1]
          : url
              .split('?v=')[1]
              .split('&t')[0]
              .split('&list')[0]
              .split('&start_radio')[0]
        : ''
    },
    showReasonForm(app_status_id, data) {
      this.$emit('close')
      this.$modal.show(
        ReasonComponent,
        {
          app_status_id: app_status_id,
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  }
}
</script>
